import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitizes a filename for safe storage by:
 * 1. Normalizing Unicode characters (converting accented chars to ASCII)
 * 2. Replacing spaces and special characters with safe alternatives
 * 3. Ensuring the result is safe for storage keys
 */
export function sanitizeFilename(filename: string): string {
  return filename
    // Normalize Unicode characters (NFD to NFC) and convert accented chars to ASCII
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove combining diacritical marks
    // Replace spaces and special characters with underscores
    .replace(/[^a-zA-Z0-9.-]/g, '_')
    // Remove multiple consecutive underscores
    .replace(/_+/g, '_')
    // Remove leading/trailing underscores
    .replace(/^_+|_+$/g, '')
    // Ensure it's not empty
    .replace(/^$/, 'untitled');
}

